import React, { memo } from 'react'
import { Stack } from '@mui/material'

import LoginLinkText from '../shared/loginLinkText/LoginLinkText'
import { LOG_IN_URL } from '../../constants/navigation'

const UserLoginLink = ({ t, extraLink }) => {
  return (
    <Stack spacing={1}>
      <LoginLinkText
        label={t('common.already-have-an-account')}
        actionLabel={t('login.log-in')}
        to={LOG_IN_URL}
      />
      {extraLink}
    </Stack>
  )
}

export default memo(UserLoginLink)
